<template>
  <!-- Supplier list dialog -->
  <v-dialog
    v-model="showDialog"
    scrollable
    max-width="1000px"
    v-on:change="dialogClose()"
  >
    <v-card>
      <v-card-title>
        <!-- Search Section -->
        <v-layout wrap>
          <v-flex xs12 sm6 md3>
            <v-text-field
              name="name"
              label="Supplier Name"
              type="text"
              class="mr-1"
              v-model="queryParams.companyName"
            ></v-text-field>
          </v-flex>

          <v-flex sm2>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <!-- Customer List Section -->
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="supplierList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td @click="setSupplier(props.item)">
                  <a>{{ props.item.companyName }}</a>
                </td>
                <td>{{ props.item.address }}</td>
                <td>{{ props.item.phone }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.contactPerson }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { Supplier } from "../../../models/model";
import { supplierService } from "../../../services/supplier-service";
export default {
  data: () => ({
    supplierList: [],
    headers: [
      { text: "Name", align: "left", value: "companyName" },
      { text: "Address", align: "left", value: "address", sortable: false },
      { text: "PhoneNo", value: "phoneNo", sortable: false },
      { text: "Email", value: "email", sortable: false },
      { text: "Contact Person", value: "contactPerson", sortable: false },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "createdDate",
      totalItems: 0,
    },
    totalRows: 0,
    supplier: new Supplier(),
    queryParams: {
      companyName: "",
      ids: [],
    },
    showListLoading: false,
    showDialog: false,
  }),
  props: {
    showSupplierListDialog: Boolean,
    poSupplierIds: Array,
  },
  watch: {
    showSupplierListDialog: function () {
      if (this.poSupplierIds) {
        this.queryParams.ids = this.poSupplierIds;
      }
      this.showDialog = !this.showDialog;
      this.onSearch();
    },
    pagination: {
      handler() {
        this.getSupplierList();
      },
      deep: true,
    },
  },
  created() {
    this.onSearch();
  },
  methods: {
    setSupplier(supplier) {
      this.supplier = supplier;
      this.$emit("changeSupplier", this.supplier);
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getSupplierList();
    },
    dialogClose() {
      this.showDialog = !this.showDialog;
    },
    getSupplierList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      supplierService
        .getSupplierList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.supplierList = res.data.supplierList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
  },
};
</script>